import React, { useEffect, useState } from "react";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { apiUrl, assetsUrl } from "../config/Config";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import userplaceholder from "../assets/images/userplaceholder.png";
import { faCoins, faXmark, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "@ramonak/react-progress-bar";
import leftborder from "../assets/images/leftborder.png";
import rightborder from "../assets/images/rightborder.png";
import AOS from "aos";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import PaypalButton from "../components/PaypalButton";

import { Button, Modal } from "react-bootstrap";

const CheckoutPage = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const inkcustomerdata = useSelector(
    (store) => store.userReducer.inkcustomerdata
  );
  // console.log("CheckoutPage inkcustomerdata >>", inkcustomerdata);
  const location = useLocation();
  // const { categoryslug, plan, subtitle, amount } = location.state || {};
  const { id, slug } = useParams();
  console.log("CheckoutPage id >>", id);

  const [couponcode, setcouponcode] = useState("");
  const [showcouponloading, setshowcouponloading] = useState(false);
  const [subtotal, setsubtotal] = useState(0);
  const [plan, setplan] = useState("");
  const [subtitle, setsubtitle] = useState("");
  const [amount, setamount] = useState(0);
  const [promodiscount, setpromodiscount] = useState(0);
  const [additionalslides, setadditionalslides] = useState(0);

  const [showloading, setshowloading] = useState(false);

  const [couponcodeerrormessage, setcouponcodeerrormessage] = useState("");
  const [successcouponmessage, setsuccesscouponmessage] = useState("");

  const [showwelcomebackmodal, setshowwelcomebackmodal] = useState(false);

  const [plandetails, setplandetails] = useState({});
  const [planloading, setplanloading] = useState(false);
  const numericSubtotal = Math.max(Number(subtotal) || 0, 0);
  const appliedPromoDiscount = Math.min(
    Math.max(Number(promodiscount) || 0, 0),
    numericSubtotal
  );
  const payableAmount = Math.max(numericSubtotal - appliedPromoDiscount, 0);
  const isNoPaymentRequired =
    !planloading && appliedPromoDiscount > 0 && payableAmount === 0;

  const handlefetchplandetails = async(id) => {
    var data = {
      planid: id
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    setplanloading(true);
    try {
      const res = await axios.post(apiUrl + "user-getplandetailsbtid", data, headers);
      if (res.data.status === "success") {
        var prevdata = res?.data?.data;
        if(prevdata && Object.keys(prevdata)?.length > 0) {
          setplandetails(prevdata);
          setplan(prevdata?.title);
          setsubtitle(prevdata?.subtitle);
          setsubtotal(prevdata?.discountamount);
          setamount(prevdata?.discountamount);
        } else {
          setplandetails({});
        }
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "inkcustomerdata", payload: {} })
          const currentUrl = window.location.href;
          localStorage.setItem("frompagetologin", currentUrl);
          navigate('/login')
        } else {
          toast.error(res.data.message || "Something went wrong!!");
          setplanloading(false);
        }
        
      }
    } catch (err) {
      console.error("API Error:", err);
      setplanloading(false);
    }
    setplanloading(false);

  }

  const handleapplycoupon = async() => {
    var iscouponcodeerror = false;
    if (couponcode) {
      iscouponcodeerror = false;
      setcouponcodeerrormessage("");
    } else {
      iscouponcodeerror = true;
      setcouponcodeerrormessage("Enter Coupon code");
    }

    if (!iscouponcodeerror) {
      console.log("validation passed !!");
    } else {
      setsuccesscouponmessage("");
      setpromodiscount(0);
      setadditionalslides(0);
      return;
    }

    if(couponcode == "NewUser") {
      if(!inkcustomerdata?.currentplan) {

      } else {
        toast.error("Invalid Coupon");
        return;
      }
    } else {

    }

    var data = {
      couponcode: couponcode,
      
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + inkcustomerdata?.token,
      },
    };

    setshowcouponloading(true);

    try {
      const res = await axios.post(apiUrl + "user-applycoupon", data, headers);
      if (res.data.status === "success") {
        setshowcouponloading(false);
        setcouponcodeerrormessage("");
        setsuccesscouponmessage("Applied Successfully!!");
        var gottype = res?.data?.type;
        var gotvalue = res?.data?.value;
        if(gottype == "Credit") {
          setpromodiscount(0);
          setadditionalslides(gotvalue);
        } else if (gottype == "Percentage") {
          var newvalue = (subtotal * gotvalue) / 100;
          setpromodiscount(newvalue);
          setadditionalslides(0);
        } else if (gottype == "Flat") {
          setpromodiscount(gotvalue);
          setadditionalslides(0)
        }
        
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "inkcustomerdata", payload: {} })
          navigate('/login')
          setsuccesscouponmessage("");
          setpromodiscount(0);
          setadditionalslides(0);
        } else {
          toast.error(res.data.message || "Something went wrong!!");
          setcouponcodeerrormessage("Invalid Coupon");
          setsuccesscouponmessage("");
          setshowcouponloading(false);
          setpromodiscount(0);
          setadditionalslides(0);
        }
        
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
      setshowcouponloading(false);
      setsuccesscouponmessage("");
      setpromodiscount(0);
      setadditionalslides(0);
    }
    setshowcouponloading(false);
  };

  const handleapplycoupon1 = async(coupon) => {
    if(!inkcustomerdata?.currentplan) {
      var data = {
        couponcode: coupon,
      };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + inkcustomerdata?.token,
        },
      };
  
      try {
        const res = await axios.post(apiUrl + "user-applycoupon", data, headers);
        if (res.data.status === "success") {
          setshowcouponloading(false);
          setshowwelcomebackmodal(false);
          setcouponcodeerrormessage("");
          setsuccesscouponmessage("Applied Successfully!!");
          var gottype = res?.data?.type;
          var gotvalue = res?.data?.value;
          setcouponcode(coupon);
          if(gottype == "Credit") {
            setpromodiscount(0);
            setadditionalslides(gotvalue);
          } else if (gottype == "Percentage") {
            var newvalue = (subtotal * gotvalue) / 100;
            setpromodiscount(newvalue);
            setadditionalslides(0);
          } else if (gottype == "Flat") {
            setpromodiscount(gotvalue);
            setadditionalslides(0)
          }
          
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "inkcustomerdata", payload: {} })
            navigate('/login')
            // setsuccesscouponmessage("");
            // setpromodiscount(0);
            // setadditionalslides(0);
          } else {
            // toast.error(res.data.message || "Something went wrong!!");
            // setcouponcodeerrormessage("Invalid Coupon");
            // setsuccesscouponmessage("");
            // setshowcouponloading(false);
            // setpromodiscount(0);
            // setadditionalslides(0);
          }
          
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        // setshowcouponloading(false);
        // setsuccesscouponmessage("");
        // setpromodiscount(0);
        // setadditionalslides(0);
      }
    } else {

    }
    setshowwelcomebackmodal(false);
    // setshowcouponloading(false);
  };

  const handlesuccessfunction = async(paymentid) => {
    if(inkcustomerdata && Object.keys(inkcustomerdata)?.length > 0) {

    } else {
      // alert('User not logged in >>');
      dispatch({ type: "inkcustomerdata", payload: {} });
      const currentUrl = window.location.href;
      localStorage.setItem("frompagetologin", currentUrl);
      navigate('/login')
      

      // const redirectUrl = localStorage.getItem("redirecturl");
      // console.log('redirectUrl >>', redirectUrl);
      // localStorage.removeItem("redirecturl");
      // window.open(redirectUrl, "_blank");
      
      return;
    }
    var gettotalslides = 0;

    if(plandetails?.type) {
      if(plandetails?.type == "fixed" || plandetails?.type == "both") {
        gettotalslides = plandetails?.noofslides;
      } else {
        gettotalslides = "Unlimited";
      }
    } else {
      alert("Invalid Plan Details");
      return;
    }


    var data = {
      plan: plan,
      planid: plandetails?.id,
      slides: gettotalslides,
      additional_slides: additionalslides,
      subtotal: amount,
      promodiscount: appliedPromoDiscount,
      promocode: couponcode,
      total: payableAmount,
      paymentid: paymentid
    }
    console.log('handlesuccessfunction data >>', data);
    // return;
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + inkcustomerdata?.token,
      },
    };
    

    setshowloading(true);

    try {
      const res = await axios.post(apiUrl + "user-subscribe", data, headers);
      if (res.data.status === "success") {
        dispatch({ type: "inkcustomerdata", payload: res.data.data })
        setshowloading(false);
        // navigate('/user-profile');
        const redirecturl = localStorage.getItem("redirecturl");
            if(redirecturl) {
              localStorage.removeItem("redirecturl");
              window.location.href = redirecturl;
            } else {
              navigate('/user-profile');
            }
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "inkcustomerdata", payload: {} })
          const currentUrl = window.location.href;
          localStorage.setItem("frompagetologin", currentUrl);
          navigate('/login')
        } else {
          toast.error(res.data.message || "Something went wrong!!");
          setshowloading(false);
        }
        
      }
    } catch (err) {
      console.error("API Error:", err);
      setshowloading(false);
    }
    setshowloading(false);
  }

  const handleSuccess = async(details) => {
    console.log('Transaction completed by', details.payer.name.given_name);
    console.log('details >>>', details);
    handlesuccessfunction(details?.id ? details?.id : "Test001");


    // var prevdata = cartdataRef.current;
    // prevdata['payid'] = details?.id;

    // setshowloading(true);
    //   const headers = {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   };
    //   let resp = await axios
    //     .post(apiUrl + "paymentsuccessfull", prevdata, headers)
    //     .then((res) => {
    //       console.log('res >>>', res.data.data)
    //       if (res.data.status == "success") {
    //         navigate('/thankyou', { replace: true });
    //         setshowloading(false);
    //       } else {
    //         navigate('/thankyou', { replace: true });
    //         // alert(res.data.message);
    //         setshowloading(false);
    //       }
    //     })
    //     .catch((err) => {
    //       navigate('/thankyou', { replace: true });
    //       // setshowloading(false);
    //       alert(err.message);
    //     });
    //     setshowloading(false);



    

  };

  const handleCancel = async(data) => {
    console.log('Payment cancelled', data);
    if(!inkcustomerdata?.currentplan) {
      // First Time
      setshowwelcomebackmodal(true);
    } else {

    }
  };

  const handleNoPaymentCheckout = () => {
    if (showloading) {
      return;
    }

    const randomPaymentId =
      typeof window.crypto?.randomUUID === "function"
        ? window.crypto
            .randomUUID()
            .replaceAll("-", "")
            .slice(0, 7)
            .toUpperCase()
        : Math.random().toString(36).slice(2, 9).toUpperCase();

    handlesuccessfunction(`NOPAY${randomPaymentId}`);
  };

  useEffect(() => {
    // setsubtotal(amount);
    handlefetchplandetails(id);
  }, []);

  return (
    <div className="homepage-layout userprofilebg subscriptionpagebg">
      {/* <ToastContainer
        position="top-right"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      /> */}
      <section>
        <div className="container">
          <div className="registermaindiv checkoutpage-box">
            <div className="ordersummary-row">
            <div className="faLeftIcon">
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    onClick={() => {
                      // setshowwelcomebackmodal(false);
                      if(!inkcustomerdata?.currentplan) {
                        // First Time
                        if(promodiscount > 0 || additionalslides > 0) {
                          navigate('/subscription-list')
                        } else {
                          setshowwelcomebackmodal(true);
                        }
                        
                      } else {
                        navigate('/subscription-list')
                      }
                    }}
                    className=""
                    style={{
                      color: "rgba(255,255,255,0.7)",
                      fontSize: 24,
                      position: "relative",
                      cursor: "pointer",
                      top: 15,
                      left: 0,
                    }}
                  />
                </div>
              <p className="section1title order-summary-title">
                <span className="gradient-head">Order Summary</span>
              </p>
            </div>
            <p className="subscription-title checkoutpage-plantitle">{plan}</p>
            <p className="subscription-sub-title">{subtitle}</p>
            <hr className="checkoutpage-hr-border" />
            <div className="checkoutpage-coupon-div">
              <div className="">
                <input
                  type="text"
                  value={couponcode}
                  onChange={(t) => {
                    setcouponcode(t.target.value);
                  }}
                  className="register-textinput form-control"
                  placeholder="Add Promo Code"
                />
                {couponcodeerrormessage ? (
                  <p className="register-error-message">
                    {couponcodeerrormessage}
                  </p>
                ) : null}
                {successcouponmessage ? (
                  <p className="register-error-message coupon-success-message">
                    {successcouponmessage}
                  </p>
                ) : null}
              </div>
              <div
                className="registersubmitbtn"
                onClick={() => {
                  if (showcouponloading) {
                  } else {
                    handleapplycoupon();
                    //   handlesignupfunc();
                  }
                }}
              >
                {showcouponloading ? (
                  <div className="spinnermaindiv">
                    <Spinner color="#fff" size={16} className="spinnerCenter" />
                  </div>
                ) : (
                  <p>Apply</p>
                )}
              </div>
            </div>
            <hr className="checkoutpage-hr-border" />
            <div className="checkoutpage-subtotalrow">
              <p className="checkoutpage-subtotaltext">Sub Total</p>
              <p className="checkoutpage-subtotaltext">USD {subtotal}</p>
            </div>
            {appliedPromoDiscount > 0 ? (
              <div className="checkoutpage-subtotalrow mt-2">
                <p className="checkoutpage-subtotaltext">Promo Discount</p>
                <p className="checkoutpage-subtotaltext">
                  - {appliedPromoDiscount}
                </p>
              </div>
            ) : null}
            {additionalslides > 0 ? (
              <div className="checkoutpage-subtotalrow mt-2">
                <p className="checkoutpage-subtotaltext">Extra</p>
                <p className="checkoutpage-subtotaltext">
                  + {additionalslides} Slides
                </p>
              </div>
            ) : null}

            <hr className="checkoutpage-hr-border" />
            <div className="checkoutpage-subtotalrow mt-2">
              <p className="checkoutpage-subtotaltext">Total</p>
              <p className="checkoutpage-subtotaltext">
                USD {payableAmount}
              </p>
            </div>
            <br />
            {planloading ? (
              <div className="spinnermaindiv">
                <Spinner color="#fff" size={22} className="spinnerCenter" />
              </div>
            ) : payableAmount > 0 ? (
              <PaypalButton
                amount={payableAmount}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
                height={45}
              />
            ) : isNoPaymentRequired ? (
              <>
                <p className="coupon-success-message">
                  Your coupon covers the full checkout amount. No payment is
                  required.
                </p>
                <div
                  className="registersubmitbtn"
                  onClick={handleNoPaymentCheckout}
                >
                  {showloading ? (
                    <div className="spinnermaindiv">
                      <Spinner
                        color="#fff"
                        size={16}
                        className="spinnerCenter"
                      />
                    </div>
                  ) : (
                    <p>Activate Plan</p>
                  )}
                </div>
              </>
            ) : (
              <p className="register-error-message">
                Please select a valid plan to continue.
              </p>
            )}
            {/* <div
              className="registersubmitbtn"
              onClick={() => {
                if (showloading) {
                } else {
                  handlesuccessfunction("PAYID001");
                }
              }}
            >
              {showloading ? (
                <div className="spinnermaindiv">
                  <Spinner color="#fff" size={16} className="spinnerCenter" />
                </div>
              ) : (
                <p>Proceed to pay</p>
              )}
            </div> */}
          </div>
        </div>
      </section>

      {/* Hold On Pop Up */}
      <Modal
        show={showwelcomebackmodal}
        onHide={() => setshowwelcomebackmodal(false)}
        size="lg"
        className="custom-width-modal custom-welcome-popup custom-lowcredits-popup welcomebackmodal-popup"
      >
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="custom-welcome-main-rightdiv custom-lowcredits-popup-main">
              <div className="header-dropdown-crossrow">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={() => {
                    setshowwelcomebackmodal(false);
                  }}
                  className=""
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: 20,
                    position: "relative",
                    cursor: "pointer",
                    top: 0,
                    left: 0,
                  }}
                />
              </div>
              <p className="section1title">
                <span className="gradient-head">
                  Wait! Don't Miss This Offer
                </span>
              </p>
              <p className="lowcredits-popup-description">
                Complete your purchase now and get an exclusive discount on your
                plan. This offer is available for a limited time only.
              </p>
              <div className="userprofile-purchasebuttondiv">
                <div
                  className="registersubmitbtn"
                  onClick={() => {
                    // navigate("/subscription-list");
                    handleapplycoupon1("NewUser");
                  }}
                >
                  <p>Claim Discount & Continue</p>
                </div>
                <div className="checkout-gobackbtn" onClick={() => {
                  navigate('/subscription-list')
                }}>
                  <p>Cancel</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CheckoutPage;
